import React from 'react';
import Footer from './Footer';
import Header from './Header';
import PropTypes from 'prop-types';
import {Box, styled} from '@mui/material';
import {useLocation, useNavigate} from 'react-router-dom';
import {logout} from './ApplicationSlice';
import {useDispatch} from 'react-redux';
import GlobalSnackbar from '../shared-components/GlobalSnackbar';
import useUser from '../utility/hooks/useUser';

const AppLayoutContainer = styled(Box)({
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
});

const MainContainer = styled('main')(({theme, isEmbedded}) => ({
    minHeight: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: isEmbedded ? '#ffffff' : '#F0F4F8',
}));

const AppLayout = ({children}) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user, account} = useUser();
    const isEmbedded = searchParams.get('embedded') === 'true';

    const handleLogout = () => {
        dispatch(logout())
            .then(_ => {
                navigate('/login');
            });
    };

    return (
        <AppLayoutContainer>
            {!isEmbedded && <Header
                account={account}
                displayActions={user?.id !== undefined && account.isAuthenticated}
                handleLogout={handleLogout}/>}
            <MainContainer isEmbedded={isEmbedded}>
                {children}
            </MainContainer>
            {!isEmbedded && <Footer/>}
            <GlobalSnackbar/>
        </AppLayoutContainer>
    );
};

AppLayout.propTypes = {
    children: PropTypes.object.isRequired,
};

export default AppLayout;